import React from 'react';
import {Errors} from '../../../partials/Partials';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import { LawyerContext } from '../../../partials/Context';


class PremiumLawyersBenefits extends React.Component {
    static contextType = LawyerContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lawyers: [],
            errors: [],
        }
    }

    componentDidMount() {
        fetch("/api/premium_lawyers/").then(res => res.json().then(
            data =>{
                this.setState({
                    lawyers: data
                })      
            }
        )).catch((err) => {
            this.setState({
                errors: err
            })
        })
    }

    render() {
        const {lawyers, errors} = this.state
        const {lawyer_wallet_url, is_premium} = this.context;
        
        if(is_premium === false) {
            return(
                <React.Fragment>
                    <Errors errors={errors} />
                    <PremiumLawyers lawyers={lawyers}/>
                    <Benefits lawyer_wallet={lawyer_wallet_url} />
                </React.Fragment>
            )
        } else {
            return null
        }
    }
}

class PremiumLawyers extends React.Component {
    render () {
        const {lawyers} = this.props
        let list = [];
        lawyers.map((item, i) => {
            list.push(
                <Lawyer lawyer={lawyers[i]} key={i}/>
            )
            return list
        })
        return (
            <div className="premium-lawyers top-buffer">
                <h2>Inni prawnicy zdobywają klientów z&nbsp;kontem PREMIUM</h2>
                <div className="row">
                        {list}
                </div>
            </div>
        )
    }
}

class Lawyer extends React.Component {
    render() {
        const {lawyer} = this.props
        return (
            <div className="col-sm-6">
                <div className="premium-lawyer">
                    <div className="avatar">
                        <a href={lawyer.url} target="_blank" rel="noreferrer">
                            <img src={lawyer.photo_url} alt="zdjęcie profilowe prawnika"/>
                            <FontAwesomeIcon icon={faStar} />
                        </a>
                    </div>
                    <div>
                        <p className="text-primary bold"><a href={lawyer.url} target="_blank" rel="noreferrer">{lawyer.name}</a></p>
                        <p>{lawyer.title} ({lawyer.city})</p>
                    </div>
                </div>
            </div>
        )
    }
}

class Benefits extends React.Component {
    render() {
        const {lawyer_wallet} = this.props
        return (
            <React.Fragment>
                <div className="top-buffer premium-lawyers-benefits">
                    <p>Konto Premium m.in.:</p>
                    <ul>
                        <li> zapewni Ci wysoką pozycję w wynikach wyszukiwania w&nbsp;naszym serwisie jak i wyszukiwarkach zewnętrznych</li>
                        <li> odkrywa klientowi pełne dane Twojej kancelarii (adres, numer telefonu, stronę www)</li>
                        <li> umożliwia odpowiadanie na pytania klientów oraz umawianie wizyt i&nbsp;zakup Twoich usług</li>
                    </ul>


                    <p>Konto PREMIUM to dodatkowe opcje stwarzające dużo większe możliwości pozyskania klientów obsługiwanych w&nbsp;serwisie.</p>
                </div>
                <div className="text-right top-buffer">
                    <a className="fl-btn" href={lawyer_wallet}>Wybierz teraz konto Premium</a>
                </div>
            </React.Fragment>
        )
    }
}



export default PremiumLawyersBenefits;